export default "/images/428774555aa9c58bf14bbc1f57bee3e6.avif";